import Components from "../components";

class DropdownSelect extends Components.Base {
  initialize() {
    this.$items = this.$el.find(".dropdown-item");
    this.$inputField = this.$el.find("input[type='hidden']")
    this.$toggle = this.$el.find(".dropdown-toggle");
  }

  bind() {
    this.$items.on('click', this.onDropdownSelect.bind(this));
  }

  onDropdownSelect(evt) {
    const $target = $(evt.target);
    this.$items.removeClass("active")
    $target.addClass("active")
    this.$toggle.html($target.html())
    this.$inputField.val($target.data("updatedValue"));
  }
}

Components.collection.register({
  selector: '.c-dropdown-select',
  klass: DropdownSelect,
});
